import { useSyncExternalStore } from 'react';

export type Language = 'cs' | 'en';

const STORAGE_KEY = 'bd_docs_language';

function readStored(): Language {
  if (typeof localStorage === 'undefined') return 'cs';
  const v = localStorage.getItem(STORAGE_KEY);
  return v === 'en' ? 'en' : 'cs';
}

const listeners = new Set<() => void>();

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  const onStorage = (e: StorageEvent) => {
    if (e.key === STORAGE_KEY) cb();
  };
  window.addEventListener('storage', onStorage);
  return () => {
    listeners.delete(cb);
    window.removeEventListener('storage', onStorage);
  };
}

function getSnapshot(): Language {
  return readStored();
}

/** Globální jazyk pro celý reader UI. Volá se kdekoli — re-renderuje při změně. */
export function useLanguage(): {
  lang: Language;
  setLang: (l: Language) => void;
  toggle: () => void;
} {
  const lang = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  const setLang = (l: Language) => {
    localStorage.setItem(STORAGE_KEY, l);
    listeners.forEach((cb) => cb());
  };

  return {
    lang,
    setLang,
    toggle: () => setLang(lang === 'cs' ? 'en' : 'cs'),
  };
}

/** Vrátí text v aktuálně zvoleném jazyce s fallbackem na CS. */
export function pickLang<T>(lang: Language, cs: T | null | undefined, en: T | null | undefined): T | null {
  if (lang === 'en' && en !== null && en !== undefined && (typeof en !== 'string' || en.length > 0)) {
    return en;
  }
  return cs ?? null;
}
